import { supabase } from '../../shared/supabase/supabaseClient';

type CacheEntry = { orgId: string; ids: Set<string>; at: number };

let cache: CacheEntry | null = null;
const TTL_MS = 60_000;

/** Productos con al menos una fila en `recipes` (assemble o disassemble). */
export async function getRecipeProductIds(orgId: string): Promise<Set<string>> {
  if (!orgId) return new Set();
  if (cache && cache.orgId === orgId && Date.now() - cache.at < TTL_MS) {
    return cache.ids;
  }
  const { data, error } = await supabase
    .from('recipes')
    .select('product_id')
    .eq('organization_id', orgId);
  if (error) {
    console.warn('[catalog] recipes product_ids', error.message);
    return new Set();
  }
  const ids = new Set(
    (data ?? [])
      .map((r) => (r as { product_id?: string }).product_id)
      .filter((id): id is string => typeof id === 'string' && id.length > 0),
  );
  cache = { orgId, ids, at: Date.now() };
  return ids;
}

export function invalidateRecipeProductIdsCache(): void {
  cache = null;
}
